if (!customElements.get('update-collection-count')) {
  class UpdateCollectionCount extends HTMLElement {
    constructor() {
      super();
    }

    static get observedAttributes() {
      return ['data-count'];
    }

    attributeChangedCallback() {
      this.dispatchUpdate();
    }

    dispatchUpdate() {
      document.dispatchEvent(
        new CustomEvent('exo:update-collection-count', {
          detail: { count: this.getAttribute('data-count') },
        }),
      );
    }

    connectedCallback() {
      this.dispatchUpdate();
    }
  }

  customElements.define('update-collection-count', UpdateCollectionCount);
}
